var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padding-btm-channel-link",attrs:{"id":"public-faq"}},[_c('el-row',{staticClass:"title-row",attrs:{"type":"flex","justify":"space-between"}},[_c('span',{staticClass:"text-primary text-bold"},[_vm._v(_vm._s(_vm.$t("FAQ")))]),_c('el-divider')],1),_c('div',{staticClass:"coming-soon"},[_vm._v(_vm._s(_vm.$t("COMING_SOON")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }